import { computed as d, createBlock as c, openBlock as n, unref as w, normalizeClass as i, withCtx as S, createElementBlock as g, createCommentVNode as s, createElementVNode as l, normalizeStyle as k, createVNode as z, toDisplayString as u } from "vue";
import v from "../../atoms/anchor-element/anchor-element.vue.js";
import L from "../../atoms/eyebrow/eyebrow.vue.js";
import M from "../../atoms/image-element/image-element.vue.js";
import x from "../../atoms/tag/tag.vue.js";
import { useLazyUrl as B } from "../../composables/useLazyUrl.js";
import { themeProp as j } from "../../composables/useTheme.js";
import { useTracking as E } from "../../composables/useTracking.js";
import { screenProp as W, isScreenSmall as O } from "../../utils/utilsScreen.js";
/* empty css               */
import $ from "../../utils/validators/aspect-ratio.js";
const C = ["src", "alt"], N = { class: "ds-blog-card__content" }, P = { class: "ds-blog-card__footer ds-padding-top-12" }, U = {
  class: "ds-text-small ds-color-grey-1900",
  "data-j-subtitle": ""
}, J = /* @__PURE__ */ Object.assign({
  name: "DsCardBlog"
}, {
  __name: "card-blog",
  props: {
    ...j,
    ...W,
    link: {
      type: Object,
      required: !0,
      validator: (e) => ["title", "url", "openInNewWindow", "nuxt"].every((o) => o in e)
    },
    /* Use if the image has only one set of sizes */
    image: {
      type: Object,
      default: null
    },
    /*
     * Use to render DsImageElement with different aspect ratios for screen sizes
     * Recommended for usages when horizontalMinMedium is set
     */
    imageWithSizes: {
      type: Object,
      default: null
    },
    /* @deprecated - Eyebrow prop is going to be deprecated - use tag for instead of eyebrow */
    eyebrow: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    contained: {
      type: Boolean,
      default: !1
    },
    /* Used to show a big card with more spacing */
    withSpacingLarge: {
      type: Boolean,
      default: !1
    },
    /* Image and the card content in one row within media('medium') */
    horizontalMinMedium: {
      type: Boolean,
      default: !1
    },
    aspectRatio: {
      type: String,
      default: null,
      validator: (e) => $(e)
    },
    /*
     * Use this prop to have default grey placeholder on image
     * But if the usecase requires other changes, use emitted event 'image-load-failed'
     */
    showPlaceholderOnImageError: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { trackingDataProvided: o } = E(), a = e, h = d(() => {
      var t, r, m;
      return a.horizontalMinMedium && !O(a.screen) ? `${(m = (r = (t = a.imageWithSizes) == null ? void 0 : t[a.screen]) == null ? void 0 : r.dimensions) == null ? void 0 : m.width}px` : "";
    }), b = d(() => a.link.lazyUrlEndpoint), { lazyUrl: f } = B(b), y = d(() => a.link.url || f.value);
    return (t, r) => (n(), c(v, {
      class: i(["ds-blog-card", [
        `ds-blog-card--${t.theme}`,
        { "ds-blog-card--contained": e.contained },
        { "ds-blog-card--horizontal": e.horizontalMinMedium }
      ]]),
      "tracking-data": { "component-name": "CardBlog", text: e.title, ...w(o) },
      url: y.value,
      "open-in-new-window": e.link.openInNewWindow,
      nuxt: e.link.nuxt,
      "aria-label": e.link.title,
      "data-j-link": "",
      "data-allow-mismatch": ""
    }, {
      default: S(() => [
        e.imageWithSizes ? (n(), g("div", {
          key: 0,
          style: k({ width: h.value }),
          class: i({
            "ds-margin-bottom-24": !e.withSpacingLarge,
            "ds-margin-bottom-48": e.withSpacingLarge,
            "ds-md-margin-bottom-0": e.horizontalMinMedium
          })
        }, [
          z(M, {
            image: e.imageWithSizes,
            "aspect-ratio": e.aspectRatio,
            screen: t.screen,
            class: "ds-blog-card__image",
            "show-placeholder-on-error": e.showPlaceholderOnImageError
          }, null, 8, ["image", "aspect-ratio", "screen", "show-placeholder-on-error"])
        ], 6)) : e.image ? (n(), g("div", {
          key: 1,
          class: i(["ds-blog-card__image", {
            "ds-margin-bottom-24": !e.withSpacingLarge,
            "ds-margin-bottom-48": e.withSpacingLarge,
            "ds-md-margin-bottom-0": e.horizontalMinMedium
          }])
        }, [
          l("img", {
            src: e.image.src,
            alt: e.image.name,
            "data-j-image": ""
          }, null, 8, C)
        ], 2)) : s("", !0),
        l("div", N, [
          e.eyebrow ? (n(), c(L, {
            key: 0,
            text: e.eyebrow,
            theme: t.theme,
            class: "ds-margin-bottom-8"
          }, null, 8, ["text", "theme"])) : s("", !0),
          e.tag ? (n(), c(x, {
            key: 1,
            label: e.tag,
            color: "green",
            class: i({ "ds-margin-bottom-12": !e.withSpacingLarge, "ds-margin-bottom-24": e.withSpacingLarge })
          }, null, 8, ["label", "class"])) : s("", !0),
          l("div", {
            class: i(["ds-blog-card__body", `ds-blog-card__body--${t.theme}`])
          }, [
            l("h4", {
              class: i({ "ds-heading-xsmall": !e.withSpacingLarge, "ds-heading": e.withSpacingLarge }),
              "data-j-title": ""
            }, u(e.title), 3)
          ], 2),
          l("div", P, [
            l("p", U, u(e.subtitle), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class", "tracking-data", "url", "open-in-new-window", "nuxt", "aria-label"]));
  }
});
export {
  J as default
};
